import { render, staticRenderFns } from "./seckill_order.vue?vue&type=template&id=c82dbbee&scoped=true"
import script from "./seckill_order.vue?vue&type=script&lang=js"
export * from "./seckill_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82dbbee",
  null
  
)

export default component.exports